import styled from 'styled-components'
import { COLOR } from '../../../../themes'

export const OrderManagerTabStyle = styled.form`
  width: 100%;
  height: 22px;
  padding: 14px 0 14px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${COLOR.GRAY_5};
  border-top: 1px solid ${COLOR.GRAY_5};

  .order-manager__tab {
    position: relative;

    &__input {
      display: none;
    }

    &__item {
      padding: 15px 16px;
      cursor: pointer;
    }
  }
`
